import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpWalletAccountPinCallbackCollectionResponse } from '../../../data/repository/fs-wallet-account/http-fs-wallet-account.collection';
import { UseCase } from '../../base/usecase';
import { FSWalletAccountRepository } from '../../repository/fs-wallet-account.repository';
import { PinCallbackDTO } from './interface/pin-callback.dto';

@Injectable({
  providedIn: 'root',
})
export class PinCallbackUsecase
  implements
    UseCase<PinCallbackDTO, HttpWalletAccountPinCallbackCollectionResponse>
{
  constructor(private repository: FSWalletAccountRepository) {}

  execute(
    data: PinCallbackDTO
  ): Observable<HttpWalletAccountPinCallbackCollectionResponse> {
    return this.repository.WalletPinCallback(data);
  }
}
